module.exports = __webpack_public_path__ + "img/FullAgenda.a48412cc.svg";